import { useState } from "react";
import { Tag, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errText } from "../lib/api";
import { CATEGORIES, CATEGORY_LABEL } from "../lib/constants";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const CHOICES = CATEGORIES.filter((c) => !["all", "lost-found"].includes(c.id));

// Staff-only control that moves a post to another category (owner is not notified).
export const CategoryChanger = ({ listing, onChange, size = "sm" }) => {
  const [busy, setBusy] = useState(false);
  if (listing.category === "lost-found") return null;
  const change = async (category) => {
    if (category === listing.category) return;
    setBusy(true);
    try {
      await api.post(`/staff/listings/${listing.id}/category`, { category });
      toast.success(`Moved to ${CATEGORY_LABEL[category]}`);
      onChange?.(category);
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  return (
    <Select value={listing.category} onValueChange={change} disabled={busy}>
      <SelectTrigger data-testid={`change-category-${listing.id}`} aria-label="Change category"
        className={`${size === "sm" ? "h-8 text-xs w-[190px]" : "h-9 text-sm w-[220px]"} rounded-lg gap-1.5 border-dashed border-slate-300 bg-white`}>
        {busy ? <Loader2 size={13} className="animate-spin shrink-0" /> : <Tag size={13} className="shrink-0 text-[#F5551E]" />}
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {CHOICES.map((c) => <SelectItem key={c.id} value={c.id} data-testid={`change-category-option-${c.id}`}>{c.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
};
